<template>
    <div class="school" :style="{background:'url('+ bg + ') no-repeat center',backgroundSize:'100% 100%'}">
        <h1>合作院校</h1>

        <!-- <el-row :gutter="8" type="flex"> -->
        <el-row type="flex">
            <!-- <el-col :sm="12" :md="12" :lg="18" > -->
            <el-col :xs="6" :sm="6" :md="4" :lg="2" class="iconList" v-for="(item,index) in bgPst" :key="index">
                <!-- <div class="iconList" v-for="(item,index) in bgPst" :key="index"> -->
                    <div class="icon" :style="{background: 'url(' + sprite + ') no-repeat',backgroundPositionX:bgPst[index].x,backgroundPositionY:bgPst[index].y}"></div>
                    <p>{{pList[index]}}</p>
                <!-- </div> -->
            </el-col>
        </el-row>
        
    </div>
</template>

<script>
export default {
    props:{
        bg: String
    },
    data(){
        return{
            pList:['山东医药大学','山东第一医科大学','上海健康医学院','四川大学','华中科技大学','南开大学','郑州大学','徐州医科大学','南京医科大学',
                    '西南医科大学','新疆医科大学','杭州医学院','济宁医学院','新乡医学院','蚌埠医学院','山东中医药大学','江西中医药大学','陕西中医药大学',
                    '福建中医药大学','沈阳药科大学','九江学院','临沂大学','吉林医药学院','江汉大学','中北大学','河西学院','南华大学',
                    '山东协和学院','河南科技大学','华北理工大学','青岛农业大学','马鞍山学院','河南工学院','湘南学院','潍坊学院','新乡医学院三全学院'],
            bgPst:[],
            sprite:require('@/assets/school.png')
        }
    },
    created(){
        // 4行 9列
        for(let k=0;k<36;k++){
            this.bgPst[k] = {x:0,y:0}
        }

        for(let i=0;i<9;i++){
            for(let j=0;j<4;j++){
                this.bgPst[i+9*j].x = -368-136*i+'px'
                this.bgPst[i+9*j].y = -150-186*j+'px'
            }
        }
        // ******************  查看坐标  ******************
        // console.log(this.bgPst)

    }
}
</script>

<style lang="scss" scoped>
.school{
    h1{
        font-size: vw(36);
        padding: vw(61) 0 vw(53);
        margin: 0;
        font-weight: 300;
        line-height: 1.7;
        color: $blue537;
    }

    .iconList{
        .icon{
            width: 96px;
            height: 96px;
        }

        p{
            font-size: vw(16);
            margin: 0;
            margin-top: 20px;
            margin-bottom: 20px;
            color: $font23;
        }
        
    }

    ::v-deep {
        .el-row{
            // justify-content: center;
            flex-wrap: wrap;
        }

        [class*=el-col-] {
            display: flex;
            flex-wrap: wrap;
            // justify-content: center;
            flex-direction: column;
            align-items: center;
        }

        @media only screen and (min-width: 1200px) and (max-width: 1564px){
            .el-col-lg-2 {
                // 每个图标占7位    100/7=14.2857
                width: 19.2857%;
            }
        }

        @media only screen and (min-width: 1565px){
            .el-col-lg-2 {
                // 每个图标占9位    100/9=11.1111
                width: 19.1111%;
            }
        }
        
    }

    @media only screen and (min-width: 768px) and (max-width: 991px){
        background: none !important;
    }
}
</style>